// @flow

import React, { useEffect, useState, type Node } from 'react';
import { Helmet } from 'react-helmet';
import i18n from 'i18next';

export function HtmlLang(): Node {
  const [language, setLanguage] = useState<string>(i18n.language || '');

  useEffect(() => {
    function syncLanguage() {
      setLanguage(i18n.language || '');
    }

    i18n.on('initialized', syncLanguage);
    i18n.on('languageChanged', syncLanguage);
    syncLanguage();

    return () => {
      i18n.off('initialized', syncLanguage);
      i18n.off('languageChanged', syncLanguage);
    };
  }, []);

  if (!language) {
    return null;
  }

  return <Helmet htmlAttributes={{ lang: language }} />;
}
